import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";


import { apiFetch } from "./apiFetch";

/**
 * Get Yahoo Finance connection status for the current user.
 * Returns { connected, cookieCount, updatedAt }.
 */
export async function getYahooFinanceStatus(accountId, userId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/yahooFinance/status", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId }),
  });
  checkResponse(resp);
  return resp.json();
}

/**
 * Disconnect Yahoo Finance for this user.
 */
export async function disconnectYahooFinance(accountId, userId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/yahooFinance/disconnect", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId }),
  });
  checkResponse(resp);
  return resp.json();
}

/**
 * Start a Playwright login session on the server. Returns { sessionId, headed }.
 */
export async function startYahooFinanceLogin(accountId, userId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/yahooFinance/startLogin", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || "Failed to start Yahoo Finance login");
  }
  return data;
}

/**
 * Complete login after user signed in via the server browser window.
 */
export async function completeYahooFinanceLogin(accountId, userId, sessionId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/yahooFinance/completeLogin", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId, sessionId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || "Failed to save Yahoo Finance session");
  }
  return data;
}

/**
 * Cancel an in-progress login session.
 */
export async function cancelYahooFinanceLogin(accountId, userId, sessionId) {
  const resp = await apiFetch(serverInfo.serverUrl + "/yahooFinance/cancelLogin", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId, sessionId }),
  });
  checkResponse(resp);
  return resp.json();
}

/**
 * Save Yahoo Finance cookies manually (JSON array or string).
 */
export async function saveYahooFinanceCookies(accountId, userId, cookies) {
  const resp = await apiFetch(serverInfo.serverUrl + "/yahooFinance/saveCookies", {
    method: "POST",
    body: JSON.stringify({ account_id: accountId, user_id: userId, cookies }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || "Failed to save Yahoo Finance cookies");
  }
  return data;
}
